module.exports = __webpack_public_path__ + "static/JohnLestockResume-6d9d0af7df80388390997971ca459780.pdf";